
interface LogoProps {
  size?: 'small' | 'default' | 'large';
  className?: string;
}

export default function Logo({ size = 'default', className = '' }: LogoProps) {
  const sizeClasses = {
    small: 'h-16',
    default: 'h-20',
    large: 'h-24'
  };

  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src="https://static.readdy.ai/image/7f27f7e05a988155f4210dfe443a01a1/8cc755d4eae113568d97fe7c581a8634.png" 
        alt="Car2Go Logo" 
        className={`${sizeClasses[size]} w-auto object-contain`}
        style={{ imageRendering: 'crisp-edges' }}
        loading="eager"
      />
    </div>
  );
}
